<template>
  <div
    v-touch="{
      left: () => swipeLeft(),
      right: () => swipeRight(),
    }"
    class="zoox-component zoox-carousel"
  >
    <div class="content">
      <z-icon
        v-if="!hideIcon"
        ref="prev-icon"
        :disabled="currentPage <= 1"
        class="icon"
        @click="clickPrev"
      >
        {{ leftIcon }}
      </z-icon>
      <!--@slot Slot referente ao conteúdo do slot 
             @binding {Array} paginatedItems Array dos itens paginados  
       -->
      <slot name="content" :paginatedItems="paginatedItems"> </slot>

      <z-icon
        v-if="!hideIcon"
        ref="next-icon"
        :disabled="currentPage >= numberOfPages"
        class="icon"
        @click="clickNext"
      >
        {{ rightIcon }}
      </z-icon>
    </div>
    <div v-if="!hideBullets" class="bullets-wrapper">
      <div
        v-for="(page, i) in numberOfPages"
        ref="bullet"
        :key="i"
        class="bullets"
        :class="{active: currentPage === i + 1}"
        :style="{
          width: width + 'px',
          height: height + 'px',
          backgroundColor: i + 1 === currentPage ? activeColor : defaultColor,
        }"
        @click="setPage(i)"
      ></div>
    </div>
  </div>
</template>

<script>
/**
 * @displayName Carousel
 */
export default {
  name: 'ZCarousel',
  props: {
    /**
     * Define o numero de itens por página
     */
    itemsPerPage: {
      type: Number,
      required: false,
      default: 2,
    },
    /**
     * Itens a serem consumidos pelo componente
     */
    items: {
      type: Array,
      default: () => [],
    },
    /**
     * Esconde os ícones de navegação no componente
     */
    hideIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Permite aumentar ou diminuir a largura das bullets
     */
    width: {
      type: Number,
      required: false,
      default: 10,
    },
    /**
     * Permite aumentar ou diminuir a altura das bullets
     */
    height: {
      type: Number,
      required: false,
      default: 10,
    },
    /**
     * Permite alterar a cor de fundo das bullets
     */
    defaultColor: {
      type: String,
      required: false,
      default: 'var(--black-300)',
    },
    /**
     * Permite alterar a cor de fundo das bullets quanto estiverem clicadas
     */
    activeColor: {
      type: String,
      required: false,
      default: 'var(--primary)',
    },
    /**
     * Prop que permite remover as "bullets" de paginação do componente
     */
    hideBullets: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Prop que define qual ícone vai ser mostrado a esquerda do carousel
     */
    leftIcon: {
      type: String,
      required: false,
      default: '$keyboard_arrow_left_rounded',
    },
    /**
     * Prop que define qual ícone vai ser mostrado a direita do carousel
     */
    rightIcon: {
      type: String,
      required: false,
      default: '$keyboard_arrow_right_rounded',
    },
  },
  data() {
    return {
      currentPage: 1,
    }
  },
  computed: {
    paginatedItems() {
      let end = this.itemsPerPage * this.currentPage
      return this.items.slice(end - this.itemsPerPage, end)
    },
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage)
    },
  },
  methods: {
    clickNext() {
      this.currentPage += 1
    },
    clickPrev() {
      this.currentPage -= 1
    },
    /**
     * @public
     *
     * Método para mudar a página atual de exibição
     */
    setPage(i) {
      this.currentPage = i + 1
      /**
       * Evento emitido ao trocar de página
       *
       * @property {Number} page Página atual
       */
      this.$emit('change', this.currentPage)
    },
    swipeLeft() {
      if (this.currentPage < this.numberOfPages) {
        this.currentPage += 1
      }
    },
    swipeRight() {
      if (this.currentPage > 1) {
        this.currentPage -= 1
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  .icon {
    cursor: pointer;
    height: min-content;
    align-self: center;
    margin: 0 5px;
  }

  @media screen and (max-width: 1024px) {
    .icon {
      margin: 0;
    }
  }
}
.bullets-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;

  .bullets {
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
    margin: 0 5px;

    &.active {
      border: none;
    }
  }
}
</style>
